import { DATE_FORMATS, formatDate } from '../../../utils/date-helper';

/**
 * Returns a restore password token searched in QueryString.
 *
 * @returns {string}
 */
export function getRestoreToken() {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get('restore-password-token');
}

/**
 * Returns a login for restore password searched in QueryString.
 *
 * @returns {string}
 */
export function getRestoreLogin() {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get('login');
}

const hasProperty = (entries, key) => Object.prototype.hasOwnProperty.call(entries, key);

// eslint-disable-next-line max-statements
export const convertRegistrationFormFormat = (data, isConfirmSpecialist) => {
  const result = {};

  if (hasProperty(data, 'name')) {
    result.name = data.name;
  }
  if (hasProperty(data, 'secondName')) {
    result.second_name = data.secondName;
  }
  if (hasProperty(data, 'lastname')) {
    result.last_name = data.lastname;
  }
  if (hasProperty(data, 'gender')) {
    result.gender = data.gender;
  }
  if (hasProperty(data, 'birthday') && data.birthday) {
    result.birthday = formatDate(new Date(data.birthday), DATE_FORMATS.YMD);
  }
  if (hasProperty(data, 'email')) {
    result.email = data.email;
  }
  if (hasProperty(data, 'password')) {
    result.password = data.password;
  }
  if (hasProperty(data, 'confirmPassword')) {
    result.confirm_password = data.confirmPassword;
  }
  if (hasProperty(data, 'agree')) {
    result.confirm_policy = data.agree ? 'Y' : null;
  }

  if (hasProperty(data, 'countryCode')) {
    result.country_code = data.countryCode;
  }
  if (hasProperty(data, 'cityCode')) {
    result.city_code = data.cityCode;
  }
  if (hasProperty(data, 'city')) {
    result.city = data.city;
  }
  if (hasProperty(data, 'specialization')) {
    result.specialization = data.specialization;
  }
  if (hasProperty(data, 'employer')) {
    result.employer = data.employer;
  }
  if (hasProperty(data, 'isConfirmAdvertising')) {
    if (isConfirmSpecialist) {
      result.is_agree_specialist_mailings = data.isConfirmAdvertising;
    } else {
      result.is_agree_mailings = data.isConfirmAdvertising;
    }
  }
  if (hasProperty(data, 'cityResidence')) {
    result.residence_city_id = data.cityResidence;
  }

  return result;
};
